/*
 * @Author: liuhang liuhang@nextmar.com
 * @Date: 2025-07-23 17:00:00
 * @Description: Custom hook for processing image source with CDN, internationalization, and format validation
 */
import { env } from '@/utils/env';
import { useLocale } from 'next-intl';
import type { StaticImport } from 'next/dist/shared/lib/get-img-props';

export const useImageSrc = (src: string | StaticImport) => {
  const locale = useLocale();

  // 如果src为null或undefined，返回null
  if (!src) {
    return null;
  }

  let formatSrc = src;

  // 如果src以/开头，自动添加CDN前缀，自带的width和quality参数目前S3用不到
  if (
    typeof src === 'string' &&
    !src.startsWith('http') &&
    !src.startsWith('//') &&
    !src.startsWith('blob:')
  ) {
    formatSrc = src?.startsWith('/')
      ? `${env.NEXT_PUBLIC_S3_FULL_URL}${src}`
      : `${env.NEXT_PUBLIC_S3_FULL_URL}/${src}`;
    // 国际化
    if (formatSrc.includes('{locale}')) {
      formatSrc = formatSrc.replaceAll('{locale}', `.${locale}`);
    }
  }

  // 验证文件格式;
  if (
    typeof formatSrc === 'string' &&
    !formatSrc.startsWith('blob:') &&
    !formatSrc.match(
      /jpg|jpeg|png|gif|webp|svg|ico|bmp|tiff|tif|heic|heif|avif|jfif|pjpeg|pjp|apng/,
    )
  ) {
    return null;
  }

  return formatSrc;
};
